export enum Visibility {
  Public = 'PUBLIC',
  Group = 'GROUP',
  Unlisted = 'UNLISTED',
  Private = 'PRIVATE',
} 